"use client"
import { Link } from 'react-router-dom';
import React, { useState } from 'react';

const ResponsiveMenu = () => {
    const [activeMenu, setActiveMenu] = useState(null);
    const active = (value) => setActiveMenu(value === activeMenu ? null : value),
    activeIcon = (value) => (activeMenu == value ? "mean-clicked" : ""),
    activeSubMenu = (value) =>
    value == activeMenu ? { display: "block" } : { display: "none" };

    const [activeMenus, setActiveMenus] = useState(null);
    const actives = (value) => setActiveMenus(value === activeMenus ? null : value),
    activeIcons = (value) => (activeMenus == value ? "mean-clicked" : ""),
    activeSubMenus = (value) =>
    value == activeMenus ? { display: "block" } : { display: "none" };
  return (
    <>    
    <ul>
        <li ><Link to='/'>Home</Link>
        </li>  
        <li className='menu-item-has-children'><Link to='#'>Services</Link>
            <ul className='sub-menu' style={activeSubMenu("/services/architecture")}>
                <li><Link to='/services/architecture'>Architectural</Link></li>
                <li><Link to='/services/engineering'>Engineering</Link></li>
                <li><Link to='/services/construction'>Construction</Link></li>
                <li><Link to='/services/consultancy'>Consultancy</Link></li>
            </ul>
            <a className={`mean-expand ${activeIcon("/services/architecture")}`} onClick={() => active("/services/architecture")}></a>
        </li>
        <li className='menu-item-has-children'><Link to='#'>Portfolio</Link>
            <ul className='sub-menu' style={activeSubMenu("Portfolio")}>
                <li><Link to='/gallery'>Gallery</Link></li>
                <li ><Link to='/portfolio/2-columns'>Projects</Link>
                    {/* <ul className='sub-menu'>
                        <li><Link to='/portfolio/2-columns'>2 Columns</Link></li>
                        <li><Link to='/portfolio/3-columns'>3 Columns</Link></li>
                        <li><Link to='/portfolio/4-columns'>4 Columns</Link></li>
                    </ul> */}
                </li>
                {/* <li><Link to='/portfolio/healthcare-facility'>Project Details</Link></li> */}
            </ul>
            <a className={`mean-expand ${activeIcon("Portfolio")}`} onClick={() => active("Portfolio")}></a>
        </li>
        <li ><Link to='/services/import-supply'>Import & Supply</Link></li>
        <li ><Link to='#'>Real State</Link></li>
        <li ><Link to='/about-us'>About us</Link>
            {/* <ul className='sub-menu'>
                <li><Link to='/blog'>Our Mission</Link></li>
                <li><Link to='/blog-standard'>Our Vision</Link></li>
            </ul> */}
        </li>
        <li><Link to='/contact-us'>Contact Us</Link></li>  
    </ul>  
    </>
  );
};

export default ResponsiveMenu;